// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/icon/overiew-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/icon/logo-eth.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overview-page {
  padding: 24px;
  background-color: #f9fafb;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 24px;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.title-icon.overview {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.eth-icon {
  width: 16px;
  height: 16px;
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.profit-loss-card,
.cost-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.metric-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.metric-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.metric-label {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.metric-value {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 6px;
}

.eth-icon {
  font-size: 14px;
  color: #627eea;
}

.chain-icon {
  font-size: 12px;
  margin-left: 4px;
  color: #6b7280;
}

.info-icon {
  font-size: 12px;
  color: #9ca3af;
  cursor: help;
}

.green-text {
  color: #86efac;
}

/* Responsive design */
@media (max-width: 768px) {
  .metrics-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .overview-page {
    padding: 16px;
  }
  
  .profit-loss-card,
  .cost-card {
    padding: 16px;
  }
}

@media (max-width: 1024px) {
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Overview.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yDAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yDAAuD;EACvD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF","sourcesContent":[".overview-page {\n  padding: 24px;\n  background-color: #f9fafb;\n  min-height: 100vh;\n}\n\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #111827;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.title-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.title-icon.overview {\n  background-image: url('../../public/icon/overiew-icon.png');\n}\n\n.eth-icon {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  background-image: url('../../public/icon/logo-eth.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.profit-loss-card,\n.cost-card {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.card-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n}\n\n.metric-column {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.metric-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.metric-label {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.metric-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.eth-icon {\n  font-size: 14px;\n  color: #627eea;\n}\n\n.chain-icon {\n  font-size: 12px;\n  margin-left: 4px;\n  color: #6b7280;\n}\n\n.info-icon {\n  font-size: 12px;\n  color: #9ca3af;\n  cursor: help;\n}\n\n.green-text {\n  color: #86efac;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .metrics-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .overview-page {\n    padding: 16px;\n  }\n  \n  .profit-loss-card,\n  .cost-card {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .metrics-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
